export const generateQueryParams = (
  params: Record<
    string,
    string | string[] | number | boolean | null | undefined
  >
): string => {
  return Object.entries(params)
    .flatMap(([key, value]) => {
      if (value === undefined || value === null) return [];
      if (Array.isArray(value)) {
        return value.map((item) => `${key}=${encodeURIComponent(item)}`);
      }
      return `${key}=${encodeURIComponent(value!)}`;
    })
    .join('&');
};
